export const APP_ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:token',
  APP: '/app',
  DASHBOARD: '/app/dashboard',
  CHAT: '/app/chat',
  EMPLOYEES: '/app/employees',
  ATTENDANCE: '/app/attendance',
  LEAVE: '/app/leave',
  PAYROLL: '/app/payroll',
  RECRUITMENT: '/app/recruitment',
  ONBOARDING: '/app/onboarding',
  PERFORMANCE: '/app/performance',
  TRAINING: '/app/training',
  DEPARTMENTS: '/app/departments',
  REPORTS: '/app/reports',
  SETTINGS: '/app/settings',
  MY_PROFILE: '/app/myprofile',
  TASKS: '/app/tasks',
  PROJECTS: '/app/projects',
  ROLES: '/app/roles',
  TIMESHEETS: '/app/timesheets',
  COMPANIES: '/app/companies',
  MY_COMPANY: '/app/mycompany',
  CLIENTS: '/app/clients',
  INVOICES: '/app/invoices',
  TRACKING: '/app/tracking',
  SHIFTS: '/app/shifts'
} as const;
